import BaseClient from './BaseClient';

class AdminTeamsClient extends BaseClient {
    listTeams(params) {
        const url = `/api/admin/teams`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    listSubTeams(teamId, params) {
        const url = `/api/admin/teams/${teamId}/sub-teams`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    showTeam(teamId) {
        const url = `/api/admin/teams/${teamId}`;
        return this.makeCoreApiRequest(url, 'get');
    }

    favoriteTeam(teamId) {
        const url = `/api/admin/teams/${teamId}/favorite`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteFavoriteTeam(teamId) {
        const url = `/api/admin/teams/${teamId}/favorite`;
        return this.makeCoreApiRequest(url, 'delete');
    }

    activateTeam(teamId) {
        const url = `/api/admin/teams/${teamId}/activate`;
        return this.makeCoreApiRequest(url, 'post');
    }

    suspendTeam(teamId, data) {
        const url = `/api/admin/teams/${teamId}/suspend`;
        return this.makeCoreApiRequest(url, 'post', data);
    }
}

export default new AdminTeamsClient();
